import React, { useEffect, useState } from 'react';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import { useParams, Link } from 'react-router-dom';
import PageShell from './ui/PageShell';
import { api } from '../config/api';

function ClientProfile() {
  const [clientsList, setClientsList] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    const getClientList = async (clientId) => {
      const { data } = await api.get(`/ClientsList/${clientId}`);
      setClientsList(Array.isArray(data) ? data : []);
    };
    getClientList(id);
  }, [id]);

  const client = clientsList[0];

  return (
    <PageShell
      title="Client Profile"
      subtitle="View client account details."
      breadcrumbs={[
        { label: 'Dashboard', path: '/dashboard' },
        { label: 'Clients', path: '/clients/list' },
        { label: 'Client Profile' },
      ]}
      backTo="/clients/list"
    >
      {!client ? (
        <p className="hr-empty-state">Client not found.</p>
      ) : (
        <Card style={{ maxWidth: '640px' }}>
          <ListGroup variant="flush">
            <ListGroup.Item><strong>Client Code:</strong> {client.ClientCode}</ListGroup.Item>
            <ListGroup.Item><strong>Client Name:</strong> {client.ClientName}</ListGroup.Item>
            <ListGroup.Item><strong>Services:</strong> {client.Services}</ListGroup.Item>
            <ListGroup.Item><strong>Location:</strong> {client.Location}</ListGroup.Item>
            <ListGroup.Item><strong>Primary Contact:</strong> {client.Name}</ListGroup.Item>
            <ListGroup.Item><strong>SPOC:</strong> {client.Spoc}</ListGroup.Item>
            <ListGroup.Item><strong>Mobile:</strong> {client.MobileNumber}</ListGroup.Item>
            <ListGroup.Item><strong>Email:</strong> {client.Email}</ListGroup.Item>
          </ListGroup>
        </Card>
      )}
      <div className="mt-3">
        <Link to="/clients/list" className="btn btn-outline-secondary">Back to Client List</Link>
      </div>
    </PageShell>
  );
}

export default ClientProfile;
